export const questions = [
    {
        id: 1, pergunta: 'Tipo de material que deve ser descartado no lixo de coloração azul.', alternativas: [
            { id: 1, alternativa: 'Papel', certa: true },
            { id: 2, alternativa: 'Plástico', certa: false },
            { id: 3, alternativa: 'Vidro', certa: false },
            { id: 4, alternativa: 'Metal', certa: false }
        ]
    },
    {
        id: 2, pergunta: 'Tipo de material que deve ser descartado no lixo de coloração verde.', alternativas: [
            { id: 1, alternativa: 'Papel', certa: false },
            { id: 2, alternativa: 'Plástico', certa: false },
            { id: 3, alternativa: 'Vidro', certa: true },
            { id: 4, alternativa: 'Metal', certa: false }
        ]
    },
    {
        id: 3, pergunta: 'Tipo de material que deve ser descartado no lixo de coloração vermelho.', alternativas: [
            { id: 1, alternativa: 'Papel', certa: false },
            { id: 2, alternativa: 'Plástico', certa: true },
            { id: 3, alternativa: 'Vidro', certa: false },
            { id: 4, alternativa: 'Metal', certa: false }
        ]
    },
    {
        id: 4, pergunta: 'Tipo de material que deve ser descartado no lixo de coloração amarelo.', alternativas: [
            { id: 1, alternativa: 'Papel', certa: false },
            { id: 2, alternativa: 'Plástico', certa: false },
            { id: 3, alternativa: 'Vidro', certa: false },
            { id: 4, alternativa: 'Metal', certa: true }
        ]
    },
    {
        id: 5, pergunta: "Qual o nome da energia obtida a partir da força de queda d'água?", alternativas: [
            { id: 1, alternativa: 'Solar', certa: false },
            { id: 2, alternativa: 'Hidráulica', certa: true },
            { id: 3, alternativa: 'Eólica', certa: false },
            { id: 4, alternativa: 'Biomassa', certa: false }
        ]
    },
    {
        id: 6, pergunta: 'Qual o nome da energia obtida a partir da luz solar?', alternativas: [
            { id: 1, alternativa: 'Hidráulica', certa: false },
            { id: 2, alternativa: 'Solar', certa: true },
            { id: 3, alternativa: 'Eólica', certa: false },
            { id: 4, alternativa: 'Biomassa', certa: false }
        ]
    },
    {
        id: 7, pergunta: 'Qual o nome da energia obtida a partir da força do vento?', alternativas: [
            { id: 1, alternativa: 'Eólica', certa: true },
            { id: 2, alternativa: 'Biomassa', certa: false },
            { id: 3, alternativa: 'Hidráulica', certa: false },
            { id: 4, alternativa: 'Solar', certa: false }
        ]
    },
    {
        id: 8, pergunta: 'Qual o nome da energia obtida durante a transformação de produtos de origem animal e vegetal?', alternativas: [
            { id: 1, alternativa: 'Solar', certa: false },
            { id: 2, alternativa: 'Eólica', certa: false },
            { id: 3, alternativa: 'Biomassa', certa: true },
            { id: 4, alternativa: 'Hidráulica', certa: false }
        ]
    },
]